import React from 'react'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {  faAdd } from "@fortawesome/free-solid-svg-icons";
import { Link } from 'react-router-dom';

function index() {
  return (
    <div>
      <h3 className='mb-4'>About</h3>
      <div className='row'>
        <div className='col-md-3 col-sm-12 col-lg-3'>
          <div className='index-card'>
            <h5>Sections</h5>
            <hr />
            <div className='d-flex justify-end'>
              <Link to="/about-section-add">
                <FontAwesomeIcon
                  icon={faAdd}
                  className="text-primary-icon mx-2"
                  style={{ cursor: "pointer" }}
                />
              </Link>
              {/* <Link to="/about-section-edit"><FontAwesomeIcon
                icon={faEdit}
                className="text-warning mx-2"
                style={{ cursor: "pointer" }}
              /></Link> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default index